export const TABS = ['PROBLEM', 'SOURCE', 'ACTIONS', 'PARTICIPANTS', 'RESULTS', 'RETROSPECTIVE'] as const;
export type CategoryKey = (typeof TABS)[number];

export const TITLE_CHARS_LIMIT = 150;
export const INPUT_CHARS_LIMIT = 1000;
export const INPUT_ITEMS_LIMIT = 50;
